import get from 'lodash.get';
import tracking from 'dibs-tracking';
import { getCategory, getCategories } from '../../categoryHelpers';

// MW-325: record the category and attribute information of the page and send it to GA in an even
// (this is used for personalization)
export const addPersonalizationTrackingData = (appliedFilters = []) => {
    const categories = getCategories(appliedFilters);
    const l1CategoryCode = get(getCategory(categories), 'values[0].code') || '';

    // action will be comma separated values like >
    // 'categoryL1:F, categoryL2:F_TAB, categoryL3:F_TAB_SID, material:6712, origin:3102, period:1012, creator:246'
    const action = appliedFilters
        .reduce((memo, filter) => {
            const filterName = filter.name;
            const filterCode = get(filter, 'values[0].code');

            if (filterCode) {
                memo.push(`${filterName}:${filterCode}`);
            }

            return memo;
        }, [])
        .join(', ');

    tracking.trackEvent({
        category: 'results page user tracking',
        action,
        label: l1CategoryCode,
        value: 0,
    });
};
